export default Object.freeze({
    refunded: {
        label: 'مرجوع شده',
        class: 'order-refunded',
    },
    canceled: {
        label: 'لغو شده',
        class: 'order-canceled',
    },
    pending: {
        label: 'در انتظار تایید',
        class: 'order-pending',
    },
    processing: {
        label: 'در حال پردازش',
        class: 'order-processing',
    },
    inventory: {
        label: 'پردازش انبار',
        class: 'order-inventory',
    },
    ready: {
        label: 'آماده ارسال',
        class: 'order-ready',
    },
    sent: {
        label: 'ارسال شده',
        class: 'order-sent',
    },
    completed: {
        label: 'تحویل شده',
        class: 'order-completed',
    },
});
